
<div>
  <div class="row " *ngIf="!AddGrp && !isUpdate">
    <div class="col pl-3">
      <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Group Payor </h4>
    </div>
  </div>
  <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
    <div class="row mt-4 ">
      <div class="col ">
        <div widget class="card border-0 box-shadow">
          <div class="card-body  widget-body pt-2">
            <div class="text-center text-danger">
              <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                agency to view
                details</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  List-->
  <div class="row mt-4"
    *ngIf="!AddGrp && !isUpdate && global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
    <div class="col">
      <div widget class="card border-0 box-shadow">
        <div class="card-body">
          <div class="row mt-2 mb-2 d-flex jutify-content-center align-items-center">
                 <div class="col-lg-12 col-md-12 col-sm-12">
              
        
          <div class="row alert ml-3 mr-3 alert-warning text-dark" *ngIf="deleteAlert==true">
            <strong>{{deleteError}}</strong>
          </div>
          <div class="row mt-2">
            <div class="col-lg-3">
              <div class="col-lg-12">
                <label style="font-weight:bold">Status</label>
              </div>
              <div class="col-lg-12">
                <ng-select  [clearable]="true" [searchable]="true"  [items]="filterstatusList"  
                bindLabel="lovName"
               bindValue="id"  [(ngModel)]="FilterStatus"  (ngModelChange)="getGroupPayor()" >
             </ng-select>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="col-lg-12">
                <label style="font-weight:bold">Filter By</label>
              </div>
              <div class="col-lg-12">
                <select class="form-control " [(ngModel)]="filterSelect" (change)="selected_filter(filterSelect)"
                  [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" id="Gfilterselect">
                  <!-- <option value=" "></option> -->
                  <option value="GroupName">Group</option>
                  <option value="PayorName">Payor</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="col-lg-12">
                <label [hidden]="filterSelect=='PayorName'" style="font-weight:bold">Group</label>
                <label *ngIf="filterSelect=='PayorName'" style="font-weight:bold">Payor</label>
              </div>
              <div class="col-lg-12">
                <!-- group -->
                <div [hidden]="filterSelect=='PayorName'">
                  <select [(ngModel)]="Filter_Group" class="form-control " (change)="change_group($event)"
                    [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" id="GPayorNamebutton">
                    <!-- <option value=" "></option> -->
                    <option *ngFor="let pay of GroupPayorlist" [ngValue]=pay.id>{{pay.lovName}}</option>
                  </select>&nbsp;&nbsp;
                </div>
                <!-- Payor -->
                <div *ngIf="filterSelect=='PayorName'">
                  <input type="text" [(ngModel)]="Filter_Payor" (keydown)="onKeydown($event,Filter_Payor)"
                    class="form-control " />&nbsp;&nbsp;
                </div>
              </div>
            </div>
            <!-- Apply Group -->
            <div class="col-lg-3 " [hidden]="filterSelect=='PayorName'">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('GROUP')" id="refreshgroup"></app-dropdown>&nbsp;
                <button type="button" class="btn blue-btn btn-sm" (click)="Search(Filter_Group)" id="ApplyFilterGroup"
                  [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                  Apply
                </button>
              </div>
            </div>
            <!-- Apply Payor -->
            <div class="col-lg-3 " *ngIf="filterSelect=='PayorName'">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <button type="button" class="btn blue-btn btn-sm" (click)="Search(Filter_Payor)" id="refreshpayor"
                  [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                  Apply
                </button>
              </div>
            </div>


          </div>
          <div class="row  mb-2 mt-2  pl-3 pr-3">
            <!-- Add Group Payor  -->
            <div class="col-lg-8">
              <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#modal" id="addgrouppayor"
                *ngIf="fp.grouppayorcreate" (click)="GrpCreateupdate('new','')" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">Add
                Group Payor</button>
            </div>
            <!-- Refresh  -->
            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 ">
              <button type="button" class="btn blue-btn btn-sm" (click)="refresh()" style="float:right"
                [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" id="refreshgrouppayor">
                <i class="fa fa-repeat"> Refresh </i>
              </button>
            </div>
          </div>
          <div class="row pl-3 pr-3">
            <div class="col-lg-12 ">
              <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true'
                *ngIf="global.globalAgencyId!='00000000-0000-0000-0000-000000000000'" [allowPaging]='true' [pageSettings]='initialPage'
                [filterSettings]='filterSettings' [allowFiltering]='true' (actionBegin)="onActionComplete($event)"
                [showColumnChooser]='true' (dataStateChange)='dataStateChange($event)' (resizeStop)="onResize($event)">
                <e-columns>
                  <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false' uid="Actions">
                    <ng-template #template let-data>
                      <button class="btn btn-edit-table" *ngIf="fp.grouppayorupdate" id="grouppayorupdate"
                        (click)="selectgrpdetails(data);GrpCreateupdate('edit',data);"><i class="fa fa-edit"></i></button>
                      &nbsp;
                      <button class="btn btn-delete-table" *ngIf="fp.grouppayordelete" data-bs-toggle="modal" id="grouppayordelete"
                        data-bs-target="#deletemodal" (click)=" GroupDelete(data);"><i class="fa fa-trash"></i></button>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="groupName" headerText="Group">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="payorName" headerText="Payor">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="addressLine1" headerText="Address" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="city" headerText="City" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="state" headerText="State" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="zip" headerText="Zip" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="phoneNumber" headerText="Phone number" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="defaultBillType" headerText="Bill Type" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="payorId" headerText="Payor ID" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="payerInitialName" headerText="Payor Initials" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                      <div class="d-none d-lg-block">
                        <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
          <div *ngIf="GroupPayorDataList.length == 0 &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'" class="text-center"
            style="color:red">
            <p>No data available</p>
          </div>
        </div>
        </div>
        </div>

      </div>
    </div>
  </div>
  <!-- Create & Edit -->
  <div *ngIf="AddGrp||isUpdate">
    <form [formGroup]="GroupForm">
      <div class="row mb-2">
        <div class="col pl-0">
          <div widget class="card border-0 box-shadow">
            <div class="card-header transparent  text-muted">
              <div class="row">
                <div class="col-lg-7 col-md-6 col-sm-6">
                  <h4 class="mb-0 font-header">Group / Payor</h4>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6 mt-2">
                  <button class="btn blue-btn" *ngIf="!isUpdate" [disabled]="!GroupForm.valid || isSaveorUpdateBoolean"  id="SaveGroupPayor" 
                    (click)="SaveOrUpdateGroupPayor()">
                    Save
                  </button>
                  <button class="btn blue-btn" (click)="SaveOrUpdateGroupPayor();" *ngIf="isUpdate" id="UpdateGroupPayor"
                    [disabled]="!GroupForm.valid ||isSaveorUpdateBoolean">
                    Update & Close
                  </button>
                  &nbsp;&nbsp;&nbsp;
                  <button class="btn blue-btn" (click)="cancel()" id="closegrouppayor">
                    Close
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body  widget-body pt-2">
              <div class="row alert ml-3 mr-3 alert-warning  text-dark" *ngIf="showErrorAlert==true">
                <strong>{{error}}</strong>
              </div>
              <div class="row">
                <div class="col-lg-6 pl-2">
                  <label class="mb-0 font-header">Group Payor</label>
                  <hr>
                  <div class="row mb-1">
                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <label class="label-bold">Status
                        <sup class="super-script">&nbsp;*</sup></label>
                    </div>
                    <div class="col-lg-8 col-md-6  col-sm-12 col-xs-12">
                      <ng-select  [clearable]="true" [searchable]="true" formControlName="status"  id="groupstatuslid" [items]="statusList"  
                      bindLabel="lovName"
                     bindValue="id"   [(ngModel)]="GroupPayor.statusLid"  >
                   </ng-select>
                      <!-- <select class="form-control " [(ngModel)]="GroupPayor.statusLid" formControlName="status"  id="groupstatuslid">
                     
                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                    </select> -->
                    </div>
                  </div>
                  <div class="row mb-1">

                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label class="label-bold">Group
                        <sup class="super-script">&nbsp;*</sup></label>
                    </div>
                    <div class="col-lg-4 col-md-8 col-sm-12 col-xs-12 d-inline-flex">

                      <select class="form-control" formControlName="Group" [(ngModel)]="GroupPayor.groupLid"
                        (change)="changefunction()" id="groupLid">
                        <!-- <option [ngValue]=""></option> -->
                        <option [ngValue]=i.id *ngFor="let i of GroupPayorlist">{{i.lovName}}</option>
                      </select>
                      <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('GROUP')"  id="GroupPayorlistrefresh"></app-dropdown>
                    
                    </div>
                    <div class="col-lg-4 col-md-12 col-xs-12 col-sm-12">
                      <label class="font-header">(Use BCBS when Bluecross is payor for trans claims)</label>
                    </div>
                  </div>
                  <div class="row mb-1">

                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <label class="label-bold">Payor
                        <sup class="super-script">&nbsp;*</sup></label>
                    </div>
                    <div class="col-lg-8 col-md-6  col-sm-12 col-xs-12">

                      <input type="text" formControlName="Payor" class="form-control" [(ngModel)]="GroupPayor.payorName"
                        name="Payor" (change)="changefunction()" id="grouppayor">
                    </div>
                  </div>
                  <div class="row mb-1">

                    <div class="col-lg-3 col-md-6  col-sm-12 col-xs-12">
                      <label class="label-bold">Billing Full Name</label>
                    </div>
                    <div class="col-lg-8 col-md-6   col-sm-12 col-xs-12">
                      <input type="text" class="form-control" formControlName="Billingfullname"
                      (change)="changefunction()" [(ngModel)]="GroupPayor.billingFullName" id="billingFullName"
                        name="Billingfullname">
                    </div>
                  </div>
                  <div class="row mb-1">

                    <div class="col-lg-3 col-md-6  col-sm-12 col-xs-12">
                      <label class="label-bold">Address Line 1</label>
                    </div>
                    <div class="col-lg-8 col-md-6  col-sm-12 col-xs-12">
                      <input type="text" class="form-control" formControlName="Address1" id="GPaddress"
                      (change)="changefunction()" [(ngModel)]="GroupPayor.addressLine1" name="Address1" />
                    </div>
                  </div>

                  <div class="row mb-1">

                    <div class="col-lg-3 col-md-6  col-sm-12 col-xs-12">
                      <label class="label-bold">Address Line 2</label>
                    </div>
                    <div class="col-lg-8 col-md-6  col-sm-12 col-xs-12">
                      <input type="text" class="form-control" formControlName="Address2" id="GPaddress2"
                        [(ngModel)]="GroupPayor.addressLine2" (change)="changefunction()" />
                    </div>
                  </div>
                  <div class="row mb-1">

                    <div class="col-lg-3 col-md-6  col-sm-12 col-xs-12">
                      <label class="label-bold">City State Zip</label>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12">
                      <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                          <input type="text" class="form-control" formControlName="City" (change)="changefunction()"
                            [(ngModel)]="GroupPayor.city" name="City" id="GPcity" />&nbsp;
                        </div>
                        <div class="col-lg-4 col-md-6  col-sm-12 col-xs-12">

                          <ng-select [items]="stateList" class="w-100" [searchable]="true" [clearable]="true"
                            bindLabel="name" bindValue="abbreviation" formControlName="State" [selectOnTab]="true"
                            [(ngModel)]="GroupPayor.state" (change)="changefunction()" id="GPstate">
                          </ng-select>&nbsp;
                        </div>
                        <div class="col-lg-4 col-md-6  col-sm-12 col-xs-12">
                          <input type="text" class="form-control" formControlName="Zip" [(ngModel)]="GroupPayor.zip"
                            name="Zip" (keypress)="numberOnly($event)" maxlength="10" (change)="changefunction()" id="GPzip">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row space d-none d-lg-flex mb-1">

                    <div class="col-lg-3 col-sm-12 col-md-6  col-xs-12">
                      <label class="label-bold">Phone Number</label>
                    </div>
                    <div class="col-lg-8 col-sm-12 col-md-6  col-xs-12">
                      <input type="tel" class="form-control" formControlName="Phonenumber" id="GPphone1"
                        [(ngModel)]="GroupPayor.phoneNumber" (keypress)="numberOnly($event)"
                        (ngModelChange)="PhoneFormat();" minlength="14" maxlength="14"
                        (change)="changefunction()" name="Phonenumber" />
                    </div>

                  </div>
                  <div class="row d-lg-none mb-1">
                    <div class="col-lg-3 col-sm-12 col-md-6 col-xs-12 ">
                      <label class="label-bold">Phone Number</label>
                    </div>
                    <div class="col-lg-8 col-sm-12 col-md-6  col-xs-12">
                      <input type="tel" class="form-control" formControlName="Phonenumber" id="GPphone1"
                        [(ngModel)]="GroupPayor.phoneNumber" (keypress)="numberOnly($event)"
                        (ngModelChange)="PhoneFormat();" minlength="14" maxlength="14"
                        (change)="changefunction()" name="Phonenumber" />
                    </div>

                  </div>
                  <div class="row mb-1">

                    <div class="col-lg-3 col-sm-12  col-md-6 col-xs-12">
                      <label class="label-bold">Payor Email</label>
                    </div>
                    <div class="col-lg-8 col-sm-12 col-md-6  col-xs-12">
                      <input type="text" class="form-control" formControlName="PayorEmail" id="PayorEmail"
                        [(ngModel)]="GroupPayor.payorEmail" (change)="changefunction()" name="PayorEmail"
                        (keypress)="global.preventforSpace($event)">
                    </div>
                  </div>
                  <div class="row mb-1">
                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label class="label-bold">Payor Initials
                      </label>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 d-inline-flex">
                      <select class="form-control" formControlName="PayorInitials"
                        [(ngModel)]="GroupPayor.payerInitialLid"  (change)="changefunction()" id="PayorInitial">
                        <option></option>
                        <option [ngValue]=i.Key *ngFor="let i of PayorInitialsList">{{i.Value}}</option>
                      </select>
                      <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('PAYERINITIALS')" id="PAYERINITIALSrefresh"></app-dropdown>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <label class="mb-0 font-header">Payor Details</label>
                  <hr>
                  <div class="row mb-1">

                    <div class="col-lg-3 col-sm-12 col-md-6  col-xs-12">
                      <label class="label-bold">Default Bill Type</label>
                    </div>
                    <div class="col-lg-4 col-sm-12  col-md-6 col-xs-12">
                      <input type="text" class="form-control" formControlName="BillType" id="defaultBillType"
                      (change)="changefunction()" [(ngModel)]="GroupPayor.defaultBillType" name="BillType">
                    </div>
                    <div class="col-lg-4 col-sm-12 col-md-6  col-xs-12">
                      <label class="font-header">(Used for Institutional and UB04 billing only)</label>
                    </div>
                  </div>
                  <div class="row mb-1" >

                    <div class="col-lg-3 col-sm-12  col-md-6 col-xs-12">
                      <label class="label-bold">Billing payor ID <sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-4 col-sm-12 col-md-6  col-xs-12">
                      <input type="text" class="form-control" formControlName="BillingPayorID" id="BillingPayorID"
                      (change)="changefunction()" [(ngModel)]="GroupPayor.payorId" name="BillingPayorID">
                      <!-- (keypress)="numberOnly($event)" -->
                    </div>
                    <div class="col-lg-4 col-sm-12 col-md-6  col-xs-12">
                      <label class="font-header">(Used for electronic billing only)</label>
                    </div>
                  </div>

                  <div class="row mb-1">
                    <div class="col-lg-3 col-sm-12  col-md-6 col-xs-12">
                      <label class="label-bold">State format</label>
                    </div>
                    <div class="col-lg-4 col-sm-12 col-md-6  col-xs-12">
                      <input type="text" class="form-control" formControlName="format" (change)="changefunction()"
                        [(ngModel)]="GroupPayor.stateFormat" name="format"  id="stateFormat">
                    </div>
                    <div class="col-lg-4 col-sm-12  col-md-6 col-xs-12">
                      <label class="font-header">(2 letter state abbreviation)</label>
                    </div>
                  </div>
                  <div class="row mb-1">
                    <div class="col-lg-3 col-sm-12  col-md-6 col-xs-12">
                      <label class="label-bold">837 P INS ID
                        <sup class="super-script">&nbsp;*</sup></label>
                    </div>
                    <div class="col-lg-4 col-sm-12 col-xs-12 d-inline-flex">
                      <select class="form-control" formControlName="InsID" [(ngModel)]="GroupPayor.i837PInsTypeLid"
                        name="InsID" (change)="changefunction()" id="InsID">
                        <option [ngValue]=i.id *ngFor="let i of I837">{{i.lovName}}</option>
                      </select>
                      <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('I837')" id="I837refresh"></app-dropdown>
                    </div>
                  </div>
                  <div class="row mb-1">
                    <div class="col-lg-3 col-sm-6  col-md-6 col-xs-6">
                      <label class="label-bold">ATYPICAL</label>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-md-6  col-xs-6">
                      <input class="checkbox checkbox-primary styled" formControlName="ATYPICAL"
                      (change)="changefunction()" type="checkbox" [(ngModel)]="GroupPayor.atypical" id="ATYPICAL">
                    </div>
                  </div>
                  <hr>
                  <label class="mb-0 font-header">Description</label>
                  <hr>
                  <div class="row mb-1">
                    <div class="col-lg-3 col-sm-6  col-md-6 col-xs-6">
                      <label class="label-bold">Description</label>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-md-6  col-xs-6">
                      <textarea class="form-control" formControlName="Description" (change)="changefunction()" id="description"
                        [(ngModel)]="GroupPayor.description"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-lg-10">

                  <label class="font-header">Insurance type,Claim filling indicator, Other ref code type aNumber
                    and a Group number are used for ANSI 837 electronic billing</label>
                </div>
                <div class="col-lg-2">
                  <button type="button" class="btn blue-btn float-right" [disabled]="!enableTab" data-bs-toggle="modal"
                    data-bs-target="#companymodal" (click)="assigncompanyTable()"  id="assigncompanyTable">Assign Company
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="mt-2">
                    <ejs-grid #grid [dataSource]='companyMappedArray' [allowResizing]='true'>
                      <e-columns>
                        <e-column minWidth=100 headerText="Actions">
                          <ng-template #template let-data>
                            <button class="btn btn-edit-table mr-1" (click)="updateCom(data)" data-bs-toggle="modal"
                              data-bs-target="#updatemodal" id="updateCom"><i class="fa fa-edit"></i></button>
                            <button class="btn btn-delete-table" data-bs-toggle="modal" data-bs-target="#deletemodalcompany"
                              (click)="DeleteCom(data)" id="DeleteCom"><i class="fa fa-trash"></i></button>
                          </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="companyName" headerText="Company">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="providerNo" headerText="Provider Number">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="companyFEIN" headerText="CompanyFEIN">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="claim_Filling_Ind" headerText="Claim Filling Ind ">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="billto_Name" headerText="Bill To/ Pay To Company Name">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="billto_Street" headerText="Street">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="billto_City" headerText="City">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="billto_State" headerText="State">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="billto_zipcode" headerText="Zip Code" type="number"></e-column>
                        <e-column minWidth=100 field="statusValue" headerText="Status">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                      </e-columns>
                    </ejs-grid>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- DeleteModal -->
<span id="openModal1" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodal" data-bs-backdrop="static">
  <div class="modal-dialog delete-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Delete Record</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record ?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal" (click)="deleteGroup()">Delete</button>
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
<!-- Close Modal -->
<span id="openModal2" data-bs-target="#CloseModal" data-bs-toggle="modal"></span>
<div class="modal" id="CloseModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Close</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        You want to close without save?
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn blue-btn" (click)="cancelYes()">Yes</button>
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal">No</button>
      </div>

    </div>
  </div>
</div>
<!-- Assign company modal -->
<span id="openModal3" data-bs-target="#companymodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="companymodal" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl modal-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Assign Company</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body ">
        <div class="row">
          <ejs-grid #grid class="modal-table mx-auto" [dataSource]='companyList' [allowResizing]='true'>
            <e-columns>
              <e-column minWidth=100 headerText="Select">
                <ng-template #template let-data>
                  <input type="radio" [(ngModel)]="radio" id="radio" [value]="data.id"
                    (change)="selectCompany($event,data);" name="data" class="mx-auto" data-bs-toggle="modal"
                    data-bs-target="#updatemodal">
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="companyName" headerText="Company"></e-column>
              <e-column minWidth=100 field="providerNo" headerText="Provider Number"></e-column>
              <e-column minWidth=100 field="billto_Name" headerText="Bill To/ Pay To Company Name"></e-column>
              <e-column minWidth=100 field="billto_Street" headerText="Street"></e-column>
              <e-column minWidth=100 field="billto_City" headerText="City"></e-column>
              <e-column minWidth=100 field="billto_State" headerText="State"></e-column>
              <e-column minWidth=100 field="billto_zipcode" headerText="Zip Code"></e-column>
              <e-column minWidth=100 field="statusValue" headerText="Status"></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal" (click)="reset_filter()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- update company -->
<span id="openModal4" data-bs-target="#updatemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="updatemodal" data-bs-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Update Company</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <form [formGroup]="CompanyGroup">
        <div class="modal-body">
          <div class="row alert ml-3 mr-3 alert-warning text-dark" *ngIf="comAlert==true">
            <strong>{{comError}}</strong>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <label class="label-bold">Provider No
                <sup class="super-script">&nbsp;*</sup>
              </label>
            </div>
            <div class="col-lg-6">
              <input type="text" class="form-control" formControlName="providerNo" id="providerNo"
                [(ngModel)]="GroupPayorCompanyMapping.providerNo" name="providerNo">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <label class="label-bold">CompanyFEIN
                <sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-6">
              <input type="text" class="form-control" formControlName="companyFEIN" id="companyFEIN"
                [(ngModel)]="GroupPayorCompanyMapping.companyFEIN" name="CompanyFEIN" maxlength="9" />
            </div>
            <div
              *ngIf="CompanyGroup.controls.companyFEIN.invalid && (CompanyGroup.controls.companyFEIN.dirty ||CompanyGroup.controls.companyFEIN.touched)">
              <div class="color text-center" *ngIf="CompanyGroup.controls.companyFEIN.errors">Enter maximum 9 characters
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <label class="label-bold">Claim Filling Ind
                <sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-6">
              <input type="text" class="form-control" formControlName="claim_Filling_Ind" id="claim_Filling_Ind"
                [(ngModel)]="GroupPayorCompanyMapping.claim_Filling_Ind" name="claim_Filling_Ind" />
            </div>

          </div>
          <div class="row">
            <div class="col-lg-6">
              <label class="label-bold">Taxonomy Code
              </label>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class=" col-6">
                  <input type="text" class="form-control" formControlName="taxCode_MANo" id="taxCode_MANo"
                    [(ngModel)]="GroupPayorCompanyMapping.taxCode_MANo" name="taxCode_MANo">
                </div>
                <div class=" col-6">
                  <input type="text" class="form-control" formControlName="taxCode_MCNo" id="taxCode_MCNo"
                    [(ngModel)]="GroupPayorCompanyMapping.taxCode_MCNo" name="taxCode_MCNo">
                </div>
              </div>
            </div>

          </div>

        </div>
      </form>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn" (click)="saveCompany(GroupPayorCompanyMapping);reset_filter()"
          [disabled]="!CompanyGroup.valid || isSaveorUpdateBoolean">Update & Close</button>
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal" (click)="reset_filter()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- DeleteModal -->
<span id="openModal5" data-bs-target="#deletemodalcompany" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodalcompany" data-bs-backdrop="static">
  <div class="modal-dialog delete-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Delete Record</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record ?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal"
          (click)="deleteGroupCompanyMapping()">Delete</button>
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>